import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, ToolBar } from '@1c/ui';
import Link from 'src/components/Link';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

const LS_COOKIE_ACCEPTED = 'cookieAccepted';

const EXCLUDE_PAGES = [routes.cookiePolicy];

const CookiePolicyNotification: React.FC = () => {
  const { pathname } = useLocation();

  const [show, setShow] = useState(false);

  useEffect(() => {
    const cookieAccepted = window.localStorage.getItem(LS_COOKIE_ACCEPTED);
    setShow(cookieAccepted !== 'true' && !EXCLUDE_PAGES.includes(pathname));
  }, []);

  const handleSubmit = () => {
    window.localStorage.setItem(LS_COOKIE_ACCEPTED, 'true');
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div className={styles['root']}>
      <h4>Мы используем файлы cookie.</h4>
      <div className={styles['body']}>
        Продолжая находиться на сайте, вы соглашаетесь с этим{'\n'}на условиях, указанных по{' '}
        <Link to={routes.cookiePolicy} target="_blank">
          ссылке
        </Link>
      </div>
      <div className={styles['footer']}>
        <ToolBar align="right">
          <Button mode="default" onClick={handleSubmit}>
            Принимаю
          </Button>
        </ToolBar>
      </div>
    </div>
  );
};

export default CookiePolicyNotification;
